// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlotComponent_plotWrapper__5Vqwq {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-height: 0;
    background: #111;
    color: white;
  }
  
  .PlotComponent_plotNavbar__CK0Qq {
    padding: 1rem;
    background-color: #222;
    border-bottom: 1px solid #333;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .PlotComponent_plotControls__XVtcC {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
  }
  
  .PlotComponent_plotContent__fPu6t {
    display: flex;
    flex: 1 1;
    overflow: hidden;
  }
  
  .PlotComponent_channelSidebar__jxIrP {
    width: auto;
    min-width: 150px;
    max-width: 500px;
    padding: 1rem;
    background: #1a1a1a;
    overflow-y: auto;
    border-right: 1px solid #333;
    box-sizing: border-box;
  }
  
  .PlotComponent_channelSidebar__jxIrP label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
.PlotComponent_chartArea__-rO-P {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
    padding: 1rem;
    background: #000;
    overflow: auto;
  }

.PlotComponent_panelStack__Hp7T0 {
    --plot-panel-min-height: 520px;
    --plot-chart-min-height: 420px;
    display: grid;
    grid-auto-rows: minmax(var(--plot-panel-min-height), 1fr);
    flex: 1 1;
    gap: 12px;
    min-height: 0;
}

.PlotComponent_plotPair__el\\+GC {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 12px;
    min-height: var(--plot-panel-min-height);
    min-width: 0;
    width: 100%;
}

.PlotComponent_withPsd__GWsN\\+ {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.PlotComponent_withoutPsd__ddH6- {
    grid-template-columns: minmax(0, 1fr);
}

.PlotComponent_plotPanel__Bdnys {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border: 1px solid #222;
    border-radius: 10px;
    background: #050505;
    min-height: 0;
    min-width: 0;
}

.PlotComponent_panelHeader__SDkPS {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.PlotComponent_panelTitle__x0WLa {
    font-size: 0.95rem;
    font-weight: 600;
}

.PlotComponent_panelMeta__\\+TEGJ {
    color: #9a9a9a;
    font-size: 0.8rem;
}

.PlotComponent_panelHeaderActions__-BLD- {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
}

.PlotComponent_panelButton__A9JIy {
    border: 1px solid #444;
    border-radius: 4px;
    background: #171717;
    color: #ddd;
    cursor: pointer;
    font-size: 0.8rem;
    line-height: 1;
    padding: 6px 8px;
}

.PlotComponent_panelButton__A9JIy:hover {
    background: #252525;
}

.PlotComponent_panelChart__sVUS6 {
    flex: 1 1;
    min-height: var(--plot-chart-min-height);
    min-width: 0;
}

@media (max-width: 900px) {
    .PlotComponent_plotPair__el\\+GC {
        grid-template-columns: minmax(0, 1fr);
    }
}
  
  .PlotComponent_timeAgo__KZys6 {
    color: #888888;
    font-size: 0.9em;
    margin-right: 4px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/PlotComponent/PlotComponent.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;;AAEF;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,aAAa;IACb,yDAAyD;IACzD,SAAO;IACP,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,wCAAwC;IACxC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;EAEE;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":[".plotWrapper {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    background: #111;\n    color: white;\n  }\n  \n  .plotNavbar {\n    padding: 1rem;\n    background-color: #222;\n    border-bottom: 1px solid #333;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .plotControls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    align-items: center;\n  }\n  \n  .plotContent {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n  }\n  \n  .channelSidebar {\n    width: auto;\n    min-width: 150px;\n    max-width: 500px;\n    padding: 1rem;\n    background: #1a1a1a;\n    overflow-y: auto;\n    border-right: 1px solid #333;\n    box-sizing: border-box;\n  }\n  \n  .channelSidebar label {\n    display: block;\n    margin-bottom: 0.5rem;\n  }\n  \n.chartArea {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    min-height: 0;\n    padding: 1rem;\n    background: #000;\n    overflow: auto;\n  }\n\n.panelStack {\n    --plot-panel-min-height: 520px;\n    --plot-chart-min-height: 420px;\n    display: grid;\n    grid-auto-rows: minmax(var(--plot-panel-min-height), 1fr);\n    flex: 1;\n    gap: 12px;\n    min-height: 0;\n}\n\n.plotPair {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 12px;\n    min-height: var(--plot-panel-min-height);\n    min-width: 0;\n    width: 100%;\n}\n\n.withPsd {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n}\n\n.withoutPsd {\n    grid-template-columns: minmax(0, 1fr);\n}\n\n.plotPanel {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px;\n    border: 1px solid #222;\n    border-radius: 10px;\n    background: #050505;\n    min-height: 0;\n    min-width: 0;\n}\n\n.panelHeader {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.panelTitle {\n    font-size: 0.95rem;\n    font-weight: 600;\n}\n\n.panelMeta {\n    color: #9a9a9a;\n    font-size: 0.8rem;\n}\n\n.panelHeaderActions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.panelButton {\n    border: 1px solid #444;\n    border-radius: 4px;\n    background: #171717;\n    color: #ddd;\n    cursor: pointer;\n    font-size: 0.8rem;\n    line-height: 1;\n    padding: 6px 8px;\n}\n\n.panelButton:hover {\n    background: #252525;\n}\n\n.panelChart {\n    flex: 1;\n    min-height: var(--plot-chart-min-height);\n    min-width: 0;\n}\n\n@media (max-width: 900px) {\n    .plotPair {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n  \n  .timeAgo {\n    color: #888888;\n    font-size: 0.9em;\n    margin-right: 4px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"plotWrapper": `PlotComponent_plotWrapper__5Vqwq`,
	"plotNavbar": `PlotComponent_plotNavbar__CK0Qq`,
	"plotControls": `PlotComponent_plotControls__XVtcC`,
	"plotContent": `PlotComponent_plotContent__fPu6t`,
	"channelSidebar": `PlotComponent_channelSidebar__jxIrP`,
	"chartArea": `PlotComponent_chartArea__-rO-P`,
	"panelStack": `PlotComponent_panelStack__Hp7T0`,
	"plotPair": `PlotComponent_plotPair__el+GC`,
	"withPsd": `PlotComponent_withPsd__GWsN+`,
	"withoutPsd": `PlotComponent_withoutPsd__ddH6-`,
	"plotPanel": `PlotComponent_plotPanel__Bdnys`,
	"panelHeader": `PlotComponent_panelHeader__SDkPS`,
	"panelTitle": `PlotComponent_panelTitle__x0WLa`,
	"panelMeta": `PlotComponent_panelMeta__+TEGJ`,
	"panelHeaderActions": `PlotComponent_panelHeaderActions__-BLD-`,
	"panelButton": `PlotComponent_panelButton__A9JIy`,
	"panelChart": `PlotComponent_panelChart__sVUS6`,
	"timeAgo": `PlotComponent_timeAgo__KZys6`
};
export default ___CSS_LOADER_EXPORT___;
